import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Box } from '@mui/material';

import type { DeviceStatus } from '@/@types/device';

const Layout = styled(Box)<{ selected: boolean }>`
  background: #ffffff;
  border-radius: 12px;
  padding: 0 8px 0 8px;
  border: 1px solid ${(props) => (props.selected ? '#ffaaaa' : '#ffffff')};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  width: 135px;
  height: 56px;
  cursor: pointer;
  > div {
    height: 45px;
    line-height: 0;
    > .count {
      font-size: 20px;
      line-height: 30px;
      font-weight: 700;
      padding: 0;
      margin: 0;
    }
    > .title {
      font-size: 10px;
      line-height: 15px;
      font-weight: 700;
    }
  }
`;

export type HomeFilterStatus = 'all' | DeviceStatus;

interface Props {
  cardName: HomeFilterStatus;
  count: number;
  selected: boolean;
}

export default function FilterCard({ cardName, count, selected }: Props) {
  const { t } = useTranslation();

  return (
    <Layout selected={selected}>
      <img src={`/images/home/ic_${cardName}.svg`} alt="" />
      <div style={{ flexGrow: 1 }}>
        <span className="count">{count}</span>
        <br />
        <span className="title">{t(`Devices.label.${cardName}`)}</span>
      </div>
    </Layout>
  );
}
